import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {DAY_SHIFT, DESIGNATION} from "../../Config/ApiUrl";
import {formatUtcToLocal} from "../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            options: {
                name: this.$t('tenant_groups'),
                url: DAY_SHIFT,
                showHeader: true,
                showCount: true,
                columns: [
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        key: 'invoice',
                        isVisible: true
                    },
                    {
                        title: this.$t('name'),
                        type: 'text',
                        key: 'name',
                        isVisible: true,
                    },
                    {
                        title: this.$t('start_at'),
                        type: 'custom-html',
                        key: 'start_at',
                        isVisible: true,
                        // modifier: start_at => start_at ? formatUtcToLocal(start_at) : '-'
                        modifier: start_at => start_at ? start_at : '-'
                    },
                    {
                        title: this.$t('end_at'),
                        type: 'custom-html',
                        key: 'end_at',
                        isVisible: true,
                        // modifier: end_at => end_at ? formatUtcToLocal(end_at) : '-'
                        modifier: end_at => end_at ? end_at : '-'
                    },
                    {
                        title: this.$t('break_time'),
                        type: 'custom-html',
                        key: 'break_time',
                        isVisible: true,
                        modifier: (break_time) => {
                            return  break_time ? break_time.name : '-';
                        }
                    },
                    {
                        title: this.$t('color'),
                        type: 'custom-html',
                        key: 'color',
                        isVisible: true,
                        modifier: (color) => {
                            return color
                                ? `<span style="display:inline-block;width:48px;height:20px;border-radius:3px;background:${color};border:1px solid #e2e8f0;"></span>`
                                : '-';
                        }
                    },
                    {
                        title: this.$t('description'),
                        type: 'custom-html',
                        key: 'description',
                        isVisible: true,
                        modifier: (description) => {
                            return  description ? description : '-';
                        }
                    },
                    {
                        title: this.$t('holiday'),
                        type: 'custom-html',
                        key: 'is_holiday',
                        isVisible: true,
                        modifier: (is_holiday) => {
                            return is_holiday
                                ? `<span class="badge badge-pill badge-success">${this.$t('yes')}</span>`
                                : `<span class="badge badge-pill badge-secondary">${this.$t('no')}</span>`;
                        }
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'modal',
                        modifier: () => this.$can('update_day_shift')
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash-2',
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'app-confirmation-modal',
                        url: DAY_SHIFT,
                        name: 'delete',
                        modifier:( row) => this.$can('delete_day_shift') && !parseInt(row.is_default)
                    }
                ],
            },
        }
    }
}
